import { useEffect, useState } from "react";
import "./cinematic.css";

const STEPS = [700, 1500, 2700, 3700, 4600];

export default function CinematicTrailer({ exp }) {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    let timers = [];
    const run = () => {
      timers.forEach(clearTimeout);
      setPhase(0);
      timers = STEPS.map((t, i) => setTimeout(() => setPhase(i + 1), t));
    };
    run();
    const loop = setInterval(run, 6600);
    return () => { clearInterval(loop); timers.forEach(clearTimeout); };
  }, [exp.slug]);
  const A = exp.assets;
  return (
    <div data-testid="attract-trailer" className="absolute inset-0 overflow-hidden pointer-events-none">
      <img src={A.scene} alt="" aria-hidden="true" className={`absolute inset-0 w-full h-full object-cover cin-scene ${phase >= 0 ? "on" : ""}`} />
      <div className="absolute left-1/2 top-[42%] w-[min(46vw,420px)] -translate-x-1/2 -translate-y-1/2">
        {phase >= 1 && (
          <img src={A.bowl} alt="" className={`w-full ${phase === 1 ? "cin-drop" : ""}`} style={{ filter: "drop-shadow(0 26px 30px rgba(0,0,0,0.65))" }} />
        )}
        {phase >= 2 && (
          <img src={A.hero} alt={exp.headline} className={`absolute inset-0 w-full ${phase === 2 ? "cin-fill" : ""}`} style={{ filter: "drop-shadow(0 26px 32px rgba(0,0,0,0.7))" }} />
        )}
        {phase >= 3 && [0, 1, 2].map((i) => (
          <span key={i} aria-hidden="true" className="cin-steam absolute" style={{ left: `${34 + i * 15}%`, top: "4%", width: 26, height: 60, borderRadius: "50%", background: "radial-gradient(ellipse, rgba(255,255,255,0.35), transparent 70%)", filter: "blur(6px)", animationDelay: `${i * 0.8}s` }} />
        ))}
      </div>
      {phase >= 4 && (
        <img src={A.naan} alt="" className={`absolute left-[60%] top-[50%] w-[min(24vw,220px)] ${phase === 4 ? "cin-slide-r" : ""}`} style={{ filter: "drop-shadow(0 18px 22px rgba(0,0,0,0.6))" }} />
      )}
      {phase >= 4 && (
        <img src={A.sides} alt="" className={`absolute left-[14%] top-[54%] w-[min(20vw,190px)] ${phase === 4 ? "cin-slide-l" : ""}`} style={{ filter: "drop-shadow(0 18px 22px rgba(0,0,0,0.6))" }} />
      )}
      <div aria-hidden="true" className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 42%, transparent 40%, rgba(0,0,0,0.6) 85%)" }} />
      <div aria-hidden="true" className="absolute inset-0" style={{ background: "linear-gradient(to top, transparent 26%, rgba(0,0,0,0.5) 44%, rgba(0,0,0,0.5) 62%, transparent 78%)" }} />
    </div>
  );
}
